export default __webpack_public_path__ + "04a490ddd47a2dca1a0a1bc9f2ccf1d7.png";